/**
 * Vuex
 *
 * @library
 *
 * https://vuex.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import createPersistedState from "vuex-persistedstate";
import card from "./modules/card";
import auth from "./modules/auth";
import user from "./modules/user";
import profile from "./modules/profile";
import phone from "./modules/phone";
import email from "./modules/email";
import website from "./modules/website";
import address from "./modules/address";
import template from "./modules/template";
import social from "./modules/social";

Vue.use(Vuex)



export default new Vuex.Store({
  axios,
  strict: true,
  modules: {
    card,
    auth,
    profile,
    user,
    phone,
    email,
    website,
    template,
    social,
    address,
  },
  plugins: [createPersistedState()],
 
  
});